import React from 'react'

function TeamFive() {
    return (
        <div>
            {/* team area start */}
            <div className="rts-team-area-style-six rts-section-gap">
                <div className="team-bg-image-style-six">
                    <img src="assets/images/team/bg-02.png" alt="bg" />
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="title-area-style-six text-center">
                                <div className="pre-title">
                                    <img
                                        src="assets/images/banner/shape/pre-title.png"
                                        alt="pre-title"
                                    />
                                    <span className="pre">Team Members</span>
                                    <img
                                        className="two"
                                        src="assets/images/banner/shape/pre-title.png"
                                        alt="pre-title"
                                    />
                                </div>
                                <h2 className="title color-white">Finbiz Professionals</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row mt--30 g-5">
                        {/* single team area start */}
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            {/* single team start */}
                            <div className="single-team-style-six">
                                <div className="inner">
                                    <div className="thumbnail">
                                        <div className="social-team">
                                            <ul>
                                                <li>
                                                    <a href="#">
                                                        <i className="fab fa-facebook-f" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="fab fa-twitter" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="fab fa-linkedin-in" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="fab fa-youtube" />
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <a href="#">
                                            <img src="assets/images/team/tm/14.png" alt="team-image" />
                                        </a>
                                        <div className="content-inner">
                                            <div className="text">
                                                <h5 className="title">Andreas Menor</h5>
                                                <span className="designation">Sr. Manager</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* single team end */}
                        </div>
                        {/* single team end */}
                        {/* single team area start */}
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            {/* single team start */}
                            <div className="single-team-style-six">
                                <div className="inner">
                                    <div className="thumbnail">
                                        <div className="social-team">
                                            <ul>
                                                <li>
                                                    <a href="#">
                                                        <i className="fab fa-facebook-f" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="fab fa-twitter" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="fab fa-linkedin-in" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="fab fa-youtube" />
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <a href="#">
                                            <img src="assets/images/team/tm/15.png" alt="team-image" />
                                        </a>
                                        <div className="content-inner">
                                            <div className="text">
                                                <h5 className="title">Andreas Menor</h5>
                                                <span className="designation">Sr. Manager</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* single team end */}
                        </div>
                        {/* single team end */}
                        {/* single team area start */}
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            {/* single team start */}
                            <div className="single-team-style-six">
                                <div className="inner">
                                    <div className="thumbnail">
                                        <div className="social-team">
                                            <ul>
                                                <li>
                                                    <a href="#">
                                                        <i className="fab fa-facebook-f" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="fab fa-twitter" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="fab fa-linkedin-in" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="fab fa-youtube" />
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <a href="#">
                                            <img src="assets/images/team/tm/16.png" alt="team-image" />
                                        </a>
                                        <div className="content-inner">
                                            <div className="text">
                                                <h5 className="title">Andreas Menor</h5>
                                                <span className="designation">Sr. Manager</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* single team end */}
                        </div>
                        {/* single team end */}
                        {/* single team area start */}
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            {/* single team start */}
                            <div className="single-team-style-six">
                                <div className="inner">
                                    <div className="thumbnail">
                                        <div className="social-team">
                                            <ul>
                                                <li>
                                                    <a href="#">
                                                        <i className="fab fa-facebook-f" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="fab fa-twitter" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="fab fa-linkedin-in" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="fab fa-youtube" />
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <a href="#">
                                            <img src="assets/images/team/tm/17.png" alt="team-image" />
                                        </a>
                                        <div className="content-inner">
                                            <div className="text">
                                                <h5 className="title">Andreas Menor</h5>
                                                <span className="designation">Sr. Manager</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* single team end */}
                        </div>
                        {/* single team end */}
                    </div>
                </div>
            </div>
            {/* team area end */}
        </div>
    )
}

export default TeamFive